import request from '../../utils/request'
import { judgePermissions } from '@/utils/common.js'
import { resolve } from 'core-js/fn/promise'

const state = {}

const actions = {
    // 获取成绩管理列表
    getMarkingList({ dispatch }, data) {
        return new Promise((resolve)=>{
            judgePermissions(['review:list']).then(res => {
                if (res) {
                    request({
                        url: `/api/review`,
                        method: 'get',
                        params: data
                    }).then((data)=>{
                        resolve(data);
                    })
                }else {
                    resolve({data:null})
                }
            })
        })
    },
    getTeacherReviewPlanInfo({ dispatch }, id) {
        return request({
            url: `/api/review/com.tipdm:tipdm-race-web:jar:v1.10.0`,
            method: 'get'
        })
    },
    postReviewQuestion({dispatch},data){
        return new Promise((resolve)=>{
            request({
                url: `/api/review/question`,
            }).then((data)=>{
                resolve(data);
            })
        })
    },
    // 获取试卷列表
    getTestPaperList({ dispatch }, data) {
        return new Promise((resolve)=>{
            judgePermissions(['review:testPaper:list']).then(res => {
                if (res) {
                    request({
                        url: `/api/review/test_paper`,
                        method: 'get',
                        params: data
                    }).then((data)=>{
                        resolve(data);
                    })
                }else {
                    resolve({data:null})
                }
            })
        })
    },

    // 保存批阅结果
    postReviewResult({dispatch},data){
        return request({
                url: `/api/review/result`,
                method: 'post',
                data
            })
    },

    // 获取下一份
    getNextReview({dispatch},reviewerId){
        return new Promise((resolve)=>{
            request({
                url: `/api/review/next/${reviewerId}`,
            }).then((data)=>{
                resolve(data);
            })
        })
    },

    // 获取试卷标准答案
    getExamAnswer({dispatch},id){
        return new Promise((resolve)=>{
            request({
                url: `/api/review/test_paper/com.tipdm:tipdm-race-web:jar:v1.10.0/question/answer`
            }).then((data) => {
                resolve(data);
            })
        })
    },

    // 通过id获取考生答案
    getExamineeAnswer({dispatch},id){
        return new Promise((resolve)=>{
            request({
                url: `/api/exam/answer?id=com.tipdm:tipdm-race-web:jar:v1.10.0`
            }).then((data) => {
                resolve(data);
            })
        })
    },

    // 通过准考证号获取考生答案
    getAdmissionAnswer({dispatch}, id) {
        return new Promise((resolve) => {
            request({
                url: `/api/exam/answer?admissionNo=com.tipdm:tipdm-race-web:jar:v1.10.0`
            }).then((data) => {
                resolve(data);
            })
        })
    }
}

export default {
    state,
    actions
}
